<template>
  <div>
    <div class="holderListwrapper animate__animated animate__slideInRight">
      <div class="detailWrapper">
        <div class="row" v-if="this.lead">
          <div class="col-8">
            <span class="leadSource">
              <span class="date">{{lead.created_at}}</span> {{lead.enquiry_source}}
            </span>
          </div>
          <div class="col-4 text-right">
            <span class="leadId">{{lead.lead_number}}</span>
          </div>
          <div class="col-8">
            <span class="leadName">{{lead.name}}</span>
            <span class="projectName">{{lead.enquiry}}</span>

          </div>

          <div class="col-4 text-right">
            <span class="badge">{{lead.status}}</span>
          </div>
           <div class="col-12"> <span class="message">Last Updated: {{lead.updated_at}} ({{updatedDiff}} days ago)</span></div>
          <div class="col-5 mt-3">
            <span class="leadSource">Assigned</span>
            <span class="projectName">{{lead.assigned_to}}</span>
          </div>
          <div class="col-7 text-right mt-3">
            <span class="projectName" v-if="lead.email">{{lead.email}}</span>
            <span class="projectName"  v-if="lead.phone">{{lead.phone}}</span>
          </div>
          <div class="w-100"></div>
          <div class="col-6 mt-3">
            <span class="leadSource">Next Call Date</span>
            <span class="projectName">{{lead.ncd || '-'}}</span>
          </div>
          <div class="col-6 mt-3 text-right" v-if="lead.booking_date">
            <span class="leadSource">Booking Date</span>
            <span class="projectName">{{lead.booking_date}}</span>
          </div>
          <div class="w-100"></div>
          <div class="col-6 mt-3" v-if="visitDate">
            <span class="leadSource">Visit Date</span>
            <span class="projectName">{{lead.detail.visit_date}}</span>
          </div>
          <div class="col-12 mt-3" v-if="visitDate">
            <span class="leadSource">Visit Comment</span>
            <span class="projectName">{{lead.detail.visit_comment || '-'}}</span>
          </div>
          <div class="w-100"></div>
          <div class="col-6 mt-3" v-if="lead.dead_reason">
            <span class="leadSource">Dead Reason</span>
            <span class="projectName">{{lead.dead_reason}}</span>
          </div>
          <div class="col-12 mt-3" v-if="lead.dead_reason_comment">
            <span class="leadSource">Dead Reason Comment</span>
            <span class="projectName">{{lead.dead_reason_comment}}</span>
          </div>
          <div class="col-12 mt-3" v-if="lead.other_contacts">
            <span class="leadSource">Other Contacts</span>
            <span class="projectName">{{lead.other_contacts}}</span>
          </div>
          <div class="col-12 mt-3" v-if="lead.sub_source">
            <span class="leadSource">Sub Source</span>
            <span class="projectName">{{lead.sub_source}}</span>
          </div>
      </div>
    </div>
    <div class="detailWrapper detailWrapper-Comment"  v-if="this.lead">
      <div class="row">
        <div class="col-12 mt-3" >
            <h5 class="">Comments</h5>
            <div class="leadContent">
              <p
                class="more mb-0" v-html="lead.comments"
              >
              </p>
            </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      lead: null
    }
  },
  created(){
    this.$axios.get(`leads/${this.$route.params.uuid}`)
      .then(res=>{
        this.lead = res.data.lead;
        this.$store.dispatch('setActiveTitle', this.lead.lead_number);
      })
      .catch(err=>console.log(err));
  },
  updated(){
    this.executeMoreLink();
  },
  methods: {
    executeMoreLink(){
      var showChar = 121; // How many characters are shown by default
      var ellipsestext = "...";
      var moretext = "More";
      var lesstext = "Less";
      $(".more").each(function() {
        var content = $(this).html();
        if (content.length > showChar) {
          var c = content.substr(0, showChar);
          var h = content.substr(showChar, content.length - showChar);
          var html =
            c +
            '<span class="moreellipses">' +
            ellipsestext +
            '&nbsp;</span><span class="morecontent"><span>' +
            h +
            '</span>&nbsp;&nbsp;<a href="" class="morelink text-link w-500">' +
            moretext +
            "</a></span>";
          $(this).html(html);
        }
      });
      $(".morelink").click(function() {
        if ($(this).hasClass("less")) {
          $(this).removeClass("less");
          $(this).html(moretext);
        } else {
          $(this).addClass("less");
          $(this).html(lesstext);
        }
        $(this)
          .parent()
          .prev()
          .toggle();
        $(this)
          .prev()
          .toggle();
        return false;
      });
    }
  },
  computed: {
    updatedDiff(){
      return this.$moment().diff(this.$moment(this.lead.updated_at, "DD MMMM YYYY"), 'days');
    },
    visitDate() {
      return this.lead?.detail?.visit_date;
    }
  }
};
</script>
<style scoped>
.holderListwrapper {
    background: #fff;
    margin: 60px 0 0;
    padding-bottom: 120px;
}
.date {
  margin-right: 8px;
}
.detailWrapper {
  padding: 20px;
  background: #fbfbfb;
}
.detailWrapper-Comment{
  padding: 0 20px 20px;
  background: #fff;
}
.leadSource {
  font-size: 10px;
  font-weight: bold;
  color: rgba(13, 5, 0, 0.3);
  display: block;
}
span.leadName {
  display: block;
  font-size: 14px;
  color: #0d0500;
  margin: 5px 0;
  font-weight: 500;
}
span.projectName {
  font-size: 12px;
  display: block;
  color: #0d0500;
}
span.badge {
  background: #efeeee;
  border-radius: 12px;
  font-size: 12px;
  color: #0d0500;
  font-weight: bold;
  padding: 6px 10px;
}
span.info {
  display: block;
  margin: 15px 5px 0;
}
span.leadId {
  font-weight: 500;
  font-size: 12px;
  color: #0d0500;
      display: block;
    margin-bottom: 5px;
}
span.message {
  color: #0aac0f;
  font-size: 11px;
  font-weight: 500;
}
.contactWrapper {
  padding: 20px 15px;
}
.grid {
  display: table;
  margin: auto;
  text-align: center;
  padding: 10px;
}
.grid span {
  display: table;
  margin: 5px auto;
  font-size: 12px;
  font-weight: 500;
  color: #0d0500;
  opacity: 0.5;
}
.leadContent {
  padding: 20px;
}
.leadContent .date {
  font-size: 12px;
  font-weight: 500;
  color: #0d0500;
  opacity: 0.5;
  margin-bottom: 6px;
}
.leadContent p {
  font-size: 14px;
  color: #0d0500;
  letter-spacing: -0.28px;
}
.iconAction svg {
  margin-right: 5px;
  margin-top: -3px;
}
.iconAction {
  margin-right: 5px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.28px;
}
.action-holder .row {
  border-bottom: 1px solid #f5f5f5;
  padding: 20px;
}
.bottom-link a{
    font-size: 14px;
    font-weight: 500;
    color: #0D0500;
    opacity: .5;
    margin-left: 20px;
}
.disabled{
  opacity: 0.3;
  pointer-events: none;
}
.iconCircle{
  position: absolute;
      width: 10px;
    height: 10px;
    background: #f68423;
    display: block;
    border-radius: 50%;
    top: -2px;
    left: 15px;
}
</style>